export default (str1, str2) => {
  const arrCompare = str2.split('\n');
  const arr1 = str1.split('\n');
  if (arr1.length !== arrCompare.length) {
    return false;
  }
  return arr1.every((line, index) => {
    return arrCompare[index] && arrCompare[index].trim() === line.trim();
  });
};
